import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-mr-md" }
const _hoisted_2 = { class: "text-subtitle1" }
const _hoisted_3 = { class: "flex justify-end items-center" }
const _hoisted_4 = { class: "on-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Last Saved: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_download_btn = _resolveComponent("download-btn")!
  const _component_bar_x_scrollable = _resolveComponent("bar-x-scrollable")!

  return (_openBlock(), _createBlock(_component_bar_x_scrollable, { class: "report-toolbar q-pa-sm justify-between" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.report.name) + " - ", 1),
          _createVNode(_component_router_link, {
            to: {name: 'client_profile', params: {clientId: _ctx.report.client.id}},
            class: "q-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.clientName(_ctx.report.client)), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_humanize_time, {
            time: _ctx.report.lastModified
          }, null, 8, ["time"])
        ]),
        _createVNode(_component_download_btn, {
          "report-id": _ctx.report.id,
          class: "on-left",
          flat: ""
        }, null, 8, ["report-id"])
      ])
    ]),
    _: 1
  }))
}